function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 16"
}, props), React.createElement("path", {
  d: "M7.5 7.76c1.91 0 3.57-1.7 3.57-3.93C11.07 1.63 9.41 0 7.5 0 5.6 0 3.94 1.66 3.94 3.84c0 2.21 1.65 3.92 3.56 3.92zM13.1 16c1.4 0 1.9-.4 1.9-1.18 0-2.3-2.88-5.47-7.5-5.47S0 12.52 0 14.82C0 15.6.5 16 1.9 16h11.2z"
})));